__webpack_require__.p = "/ariseforyou/";